import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css, keyframes } from '@emotion/react';
import { useCallback, useMemo } from 'react';
import { BOLD_FONT_FAMILY } from '../../constants/constants';
import { hideDealingMessage } from '../../redux/actions/pokerActions';
import { useAppDispatch } from '../../redux/store';
const KEYFRAMES = keyframes `
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  15% {
    opacity: 1;
    transform: translateX(0);
  }
  70% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(+40px);
  }
`;
const ANIMATION_CSS = css `
  animation: ${KEYFRAMES} 3s forwards;
`;
export const DealingMessageDisplay = ({ text, textColor, tableAreaDimensionsW, tableAreaDimensionsH }) => {
    const dispatch = useAppDispatch();
    const onAnimationEnd = useCallback(() => {
        dispatch(hideDealingMessage());
    }, [dispatch]);
    const containerCss = useMemo(() => css `
      z-index: 1;
      color: ${textColor};
      position: absolute;
      font-family: ${BOLD_FONT_FAMILY};
      font-size: 36px;
      transform: translate(-50%, -50%) skew(-10deg);
      pointer-events: none;
      left: ${tableAreaDimensionsW / 2}px;
      top: ${tableAreaDimensionsH / 2}px;
    `, [tableAreaDimensionsH, tableAreaDimensionsW, textColor]);
    return (_jsx("aside", { css: containerCss, "data-testid": 'dealing-message', "aria-hidden": true, children: _jsx("div", { css: ANIMATION_CSS, onAnimationEnd: onAnimationEnd, children: text }) }));
};
